import { useState } from "react";
import { useTranslation } from "react-i18next";

import { IDevice } from "../../../../../../@types/Devices";
import { Notification } from "../../../../../../@types/Notification";
import { Button } from "../../../../../../components/Button";
import { devicesService } from "../../../../../../services/devicesService";
import { displayValue } from "../../../../../../utils/stringFormatter";
import {
  DeleteDeviceCancelButton,
  RemoveDeviceTitle,
  InputRow,
  InputsContainer,
  DeleteDeviceModalContainer,
  SubmitContainer,
  ContentValue,
} from "./DeleteDeviceModal.styles";

interface IDeleteDeviceModal {
  content: IDevice;
  onClose: (notification?: Notification, refetchTable?: boolean) => void;
}

export function DeleteDeviceModal({ content, onClose }: IDeleteDeviceModal) {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);

  const handleOnDeviceDelete = async () => {
    if (!content.identifier) return;

    setIsLoading(true);

    const result = await devicesService.deleteDevice(content.identifier);

    setIsLoading(false);

    const notification: Notification = {
      show: true,
      message: "",
      type: "success",
      width: "max-content",
    };

    let refetchTable = false;

    if (result.status >= 200 && result.status < 300) {
      notification.message = t("patientPage_devices_deleteModal_deleted");
      refetchTable = true;
    } else {
      notification.message = t("patientPage_devices_deleteModal_failed");
      notification.type = "error";
    }

    onClose(notification, refetchTable);
  };

  return (
    <DeleteDeviceModalContainer>
      <RemoveDeviceTitle>
        <p>{t("patientPage_devices_deleteModal_title")}</p>
      </RemoveDeviceTitle>
      <InputsContainer>
        <InputRow>
          <p>{t("patientPage_devices_deleteModal_type")}</p>
          <ContentValue>{content.name}</ContentValue>
        </InputRow>
        <InputRow>
          <p>ID</p>
          <ContentValue>{displayValue(content.identifier)}</ContentValue>
        </InputRow>
        <InputRow>
          <p>{t("patientPage_devices_deleteModal_lastUsed")}</p>
          <ContentValue>{content.lastUsed ?? "-"}</ContentValue>
        </InputRow>
      </InputsContainer>
      <SubmitContainer>
        <Button
          type="button"
          label={t("patientPage_devices_deleteModal_confirm")}
          isLoading={isLoading}
          onClick={handleOnDeviceDelete}
        />
        <DeleteDeviceCancelButton onClick={() => onClose()}>
          {t("common_cancel")}
        </DeleteDeviceCancelButton>
      </SubmitContainer>
    </DeleteDeviceModalContainer>
  );
}
